<template>
  <div class="popupWrapper">
    <GlobalEvents @keydown.esc="close" />
    <div class="topFrame">
      <AppPopupCloseButton @click="close" class="closeButton" />
      <slot />
    </div>
    <div class="bottomFrame" />
  </div>
</template>

<script>
import GlobalEvents from 'vue-global-events'
import AppPopupCloseButton from '@/components/App/AppPopupCloseButton'
export default {
  name: 'AppPopup',
  components: { AppPopupCloseButton, GlobalEvents },
  methods: {
    close() {
      this.$emit('close')
    },
  },
}
</script>

<style scoped lang="scss">
$popup-width: 260px;
$padding-horizontal: 10px;

.closeButton {
  position: absolute;
  top: -22px;
  right: -22px;
}
.popupWrapper {
  position: absolute;
  top: -125px;
  left: -$popup-width / 2 + 2px;
  z-index: 100;
}
.topFrame {
  position: relative;
  background: white;
  width: $popup-width + $padding-horizontal * 2;
  height: 100px;
  box-shadow: 6px 10px 5px -1px rgba(0, 0, 0, 0.32);
}
.bottomFrame {
  position: absolute;
  left: $popup-width / 2;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 20px 10px 0 10px;
  border-color: #ffffff transparent transparent transparent;
}
</style>
